var _desc, _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _ellipse, _ellipse2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacturi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Facturi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Pictogram\u0103 vectorial\u0103 cu document de factur\u0103 \u0219i monede.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20222B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purple",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7B248F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E1767"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 68H294L374 148V286",
    fill: "none",
    stroke: "url(#dark)",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68C83 68 68 83 68 102V394C68 413 83 428 102 428H286",
    fill: "none",
    stroke: "url(#dark)",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294 70V126C294 143 308 157 325 157H371",
    fill: "none",
    stroke: "url(#dark)",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 210,
    width: 148,
    height: 24,
    rx: 12,
    fill: "url(#dark)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 264,
    width: 148,
    height: 24,
    rx: 12,
    fill: "url(#dark)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 318,
    width: 148,
    height: 24,
    rx: 12,
    fill: "url(#dark)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270 276C270 255 308 238 355 238C402 238 440 255 440 276V398C440 420 402 438 355 438C308 438 270 420 270 398Z",
    fill: "url(#purple)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 355,
    cy: 276,
    rx: 85,
    ry: 38,
    fill: "#702184"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 355,
    cy: 276,
    rx: 85,
    ry: 38,
    fill: "url(#purple)",
    opacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M274 318C295 337 327 346 355 346C386 346 417 337 436 318",
    fill: "none",
    stroke: "#F5F2F7",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274 366C296 384 326 393 355 393C386 393 417 384 436 366",
    fill: "none",
    stroke: "#F5F2F7",
    strokeWidth: 13,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacturi);
export default __webpack_public_path__ + "static/media/facturi.57e49dd6fc71b76a253ba797cb52dcdd.svg";
export { ForwardRef as ReactComponent };